import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(() => {
  return ({
    brandedDocument: {
      borderRadius: 'var(--border-radius-lg)',
      minHeight: '180px',
      width: '220px',
      padding: '.5rem',
      border: '2px solid var(--color-primary-100)',
      boxShadow: '0px 7px 7px -5px rgba(0,0,0,0.5)',
      backgroundColor: 'var(--theme-color-surface-d0)',
      backgroundImage: ({ imageUrl }) => imageUrl ? `url(${imageUrl})` : undefined,
      backgroundPosition: 'center 25%',
      backgroundSize: '100%',
      backgroundRepeat: 'no-repeat',
      position: 'relative',
      transition: 'border .3s ease',
      '& > *:hover': {
        textDecoration: 'none !important'
      },
      '&:hover': {
        border: 'var(--border-primary-normal) !important',
        '& .__ds-title': {
          height: '54px'
        }
      },

      '& .__branded-document-title': {
        position: 'absolute',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        bottom: -2,
        left: 0,
        height: '36px',
        color: 'var(--color-primary-050)',
        width: '100%',
        fontSize: '0.85rem',
        padding: '.5rem',
        borderBottomLeftRadius: '12px',
        borderBottomRightRadius: '12px',
        backgroundColor: 'var(--color-primary-500)',
        transition: 'height .3s ease-in-out',
        overflow: 'auto'
      }
    }
  })
})

const BrandedDocument = ({ name, imageUrl, onHover, badges }) => {
  const classes = useStyles({ imageUrl })

  const badgeSection = useMemo(() => {
    if ((badges || []).length === 0) {
      return null
    }

    return (
      <div className='flex gap-xs items-center justify-center absolute top-0 right-0'>
        {badges.map((b, i) => (
          <div key={`badge-${i}`}>
            {b}
          </div>
        ))}
      </div>
    )
  }, [badges])

  return (
    <div
      className={classes.brandedDocument}
      onMouseOver={onHover}
    >
      {badgeSection}
      <div className='__branded-document-title'>{name}</div>
    </div>
  )
}

BrandedDocument.propTypes = {
  name: PropTypes.string.isRequired,
  imageUrl: PropTypes.string,
  onHover: PropTypes.func,
  badges: PropTypes.arrayOf(PropTypes.node)
}

BrandedDocument.defaultProps = {
  onHover: () => {}
}

export default BrandedDocument
